<script>
  import DataTable1 from "./DataTable1.svelte";

  export let data;

  export let show = true;

  export let nr;

  export let title;

  export let how_many_first_columns_left_align;

  function click_title() {
    show = !show;
  }
</script>

<div on:click={click_title} class="maus">
  <b>
    {#if !show}
      ▼
    {:else}
      ▲
    {/if}
    Table {nr}: {title}
  </b>
</div>
<div class="div {show ? 'shownClass' : 'hiddenClass'}">
  <div style="margin: 20px;">
    <DataTable1 {data} {how_many_first_columns_left_align} />
  </div>
</div>
{#if !show}
  <div style="width: 100%; height: 30px;" />
{/if}

<style>
  .hiddenClass {
    /*visibility: hidden;
    display: none;
    opacity:  0;
    transition: visibility 2s, opacity 2s linear;*/

    max-height: 0;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    transition: max-height 0.5s ease-in;
  }

  .shownClass {
    max-height: auto;

    opacity: 1;
    transition: max-height 0.5s ease-in;
    transition: opacity 0.5s ease-in;
  }

  .maus:hover {
    cursor: pointer;
  }
</style>
